"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _filters = require('./filters');

 const PAGE_SIZE = 50; exports.PAGE_SIZE = PAGE_SIZE












const INITIAL = { events: [], cursor: '', emptyPages: 0, hasLoaded: false, isLoading: true, hasError: false }

/* The log for the filters, newest first (or oldest first), 50 at a time.
 * New filters, a new order or a reload start over; loadMore appends the
 * next page for the same range, as the first page fixed it. A page can hold
 * fewer than 50 events and still have more after it. Only the latest
 * request's answer shows. */
 const useAuditLog = (orgKey, filters, oldest = false) => {
  const [state, setState] = _react.useState(INITIAL)
  const [reloads, setReloads] = _react.useState.call(void 0, 0)
  const request = _react.useRef(null)
  const latest = _react.useRef.call(void 0, 0)

  _react.useEffect.call(void 0, () => {
    const id = ++latest.current
    const req = { ..._filters.auditRequest.call(void 0, orgKey, filters), ...(oldest && { Oldest: true }) }
    request.current = req
    setState(s => ({ ...s, isLoading: true, hasError: false }))
    _actions2.default.listAuditEvents({ ...req, Limit: exports.PAGE_SIZE })
      .then(page => {
        if (id === latest.current) {
          setState({
            events: page.Events,
            cursor: page.Cursor,
            emptyPages: page.Events.length === 0 && page.Cursor ? 1 : 0,
            hasLoaded: true,
            isLoading: false,
            hasError: false,
          })
        }
      })
      .catch(() => {
        if (id === latest.current) setState({ ...INITIAL, isLoading: false, hasError: true })
      })
  }, [orgKey, filters, oldest, reloads])

  const loadMore = _react.useCallback.call(void 0, () => {
    const req = request.current
    if (!req || !state.cursor || state.isLoading) return
    const id = ++latest.current
    setState(s => ({ ...s, isLoading: true, hasError: false }))
    _actions2.default.listAuditEvents({ ...req, Cursor: state.cursor, Limit: exports.PAGE_SIZE })
      .then(page => {
        if (id === latest.current) {
          setState(s => ({
            ...s,
            events: [...s.events, ...page.Events],
            cursor: page.Cursor,
            emptyPages: page.Events.length === 0 ? s.emptyPages + 1 : 0,
            isLoading: false,
          }))
        }
      })
      .catch(() => {
        if (id === latest.current) setState(s => ({ ...s, isLoading: false, hasError: true }))
      })
  }, [state.cursor, state.isLoading])

  // Keep searching after the list stopped on empty pages.
  const keepSearching = _react.useCallback.call(void 0, () => {
    setState(s => ({ ...s, emptyPages: 0 }))
  }, [])

  const reload = _react.useCallback.call(void 0, () => setReloads(n => n + 1), [])

  return { ...state, hasMore: !!state.cursor, loadMore, keepSearching, reload }
}; exports.useAuditLog = useAuditLog
